import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetContractorInfoRequestSchema,
  TGetContractorInfoResponseSchema,
} from "./getContractorInfo.schema";

export const getContractorInfo = (axios: IAxiosInstance) => {
  return async (params: TGetContractorInfoRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetContractorInfoResponseSchema>
    >(`/api/getContractorInfo`, {
      params,
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
